import UltamateRewardsIdLookUpLocate from '@ulta/components/UltamateRewardsIdLookUpLocate/UltamateRewardsIdLookUpLocate';

export default UltamateRewardsIdLookUpLocate;